<template>
  <div class="mt-3">
    <div class="row">
      <div class="col">
        <ul class="lg:mb-0 list-disc mb-5 ml-5">
          <li v-html="$t('ct-checkout-gateway-paypal-info-line1')"></li>
          <li>{{ $t('ct-checkout-gateway-paypal-acess-page-here') }} <a class="underline" target="_blank"
                                                                        href="https://developer.paypal.com">
            https://developer.paypal.com/</a></li>
          <li v-html="$t('ct-checkout-gateway-paypal-info-line2')"></li>
          <li v-html="$t('ct-checkout-gateway-paypal-info-line3')"></li>
          <li v-html="$t('ct-checkout-gateway-paypal-info-line4')"></li>
          <li v-html="$t('ct-checkout-gateway-paypal-info-line5')"></li>
          <li v-html="$t('ct-checkout-gateway-paypal-info-line6')"></li>
        </ul>
      </div>
      <div class="col">
        <!-- Input Description -->
        <div class="form-group">
          <label for="name" class="control-label">{{ $t('ct-description') }}</label>
          <div class="" :class="{'has-error': e.has('name')}">
            <input type="text" class="form-control" id="name" name="name" v-model="config.name">
            <span class="label label-danger" v-if="e.has('name')">{{ e.first('name') }}</span>
          </div>
        </div>
        <!-- Input Client_id -->
        <div class="form-group">
          <label for="client_id" class="control-label">{{ $t('ct-client-id') }}</label>
          <div class="" :class="{'has-error': e.has('client_id')}">
            <input type="text" class="form-control" id="client_id" name="client_id" v-model="config.client_id">
            <span class="label label-danger" v-if="e.has('client_id')">{{ e.first('client_id') }}</span>
          </div>
        </div>
        <!-- Input Secret -->
        <div class="form-group">
          <label for="secret" class="control-label">{{ $t('ct-secret') }}</label>
          <div class="" :class="{'has-error': e.has('secret')}">
            <input type="text" class="form-control" id="secret" name="secret" v-model="config.secret">
            <span class="label label-danger" v-if="e.has('secret')">{{ e.first('secret') }}</span>
          </div>
        </div>
        <!-- Input Sandbox -->
        <div class="form-group">
          <label for="sandbox" class="control-label">
            <input type="checkbox" id="sandbox" name="sandbox" v-model="config.sandbox">
            {{ $t('ct-checkout-gateway-paypal-create-sandbox') }}
          </label>
        </div>

      </div>
    </div>
    <!-- Form Submit -->
    <div class="form-group">
      <div class="col-sm-offset-2 ">
        <button class="btn btn-default" @click="$emit('cancel')">{{ $t('ct-cancel') }}</button>
        <button type="button" class="btn btn-info" @click="save">{{ $t('ct-save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaypalConfig',
  props: ['value', 'e'],

  data() {
    return {
      config: {}
    };
  },

  watch: {
    config: {
      handler(config) {
        this.$emit('input', config);
      },
      deep: true
    },
    'value': function(val) {
      this.$emit('input', this.config);
    }
  },

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        name: 'required',
        client_id: 'required',
        secret: 'required'
      });

      this.e.validate(this.config);

      if (!this.e.any()) this.$emit('save', this.config);
    }
  },

  created() {
    this.config = JSON.stringify(this.value) !== '{}' ? this.value : {
      sandbox: false
    };
  },

  beforeDestroy() {
    this.config = {
      sandbox: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/GatewayConfig/PaypalConfig.vue